import { onUnmounted, onMounted, ref } from 'vue';

export function useGeolocation() {
    const coords = ref({ latitude: 33.312805, longitude: 44.361488 }); // Initialize with default values
    const isSupported = 'navigator' in window && 'geolocation' in navigator;
    let watcher = null;

    const updatePosition = (position) => {
        coords.value = {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
        };
    };

    const handleError = (error) => {
        console.warn("Geolocation error:", error.message);
        
        // Optionally set default coordinates if geolocation fails
        // Uncomment if you want to use example coordinates
        // coords.value = { latitude: 33.5138, longitude: 36.2765 }; // Example coordinates for Damascus
        coords.value = { latitude: 33.312805, longitude: 44.361488 }; // Fallback coordinates
    };

    onMounted(() => {
        if (isSupported) {
            navigator.geolocation.getCurrentPosition(
                updatePosition,
                handleError
            );

            watcher = navigator.geolocation.watchPosition(updatePosition, handleError);
        } else {
            console.warn("Geolocation is not supported by this browser.");
        }
    });

    onUnmounted(() => {
        if (watcher) {
            navigator.geolocation.clearWatch(watcher);
        }
    });

    return { coords, isSupported };
}